<match-display-wrapper
    matchLabel="{{ l10nKeys.portMatchLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
    [matchValuesExist]="!!editable.matchValue"
>
    {{ editable.matchValue }}
</match-display-wrapper>
